import capitalize from './helpers/capitalize'
import startCase from './helpers/startCase'

const normalizeCode = (value: string): string => capitalize(startCase(value))

export default {
  normalizeCode,
}
